import React, { useEffect } from 'react';
import { memo } from 'react';

import {
  Text,
  Icon,
  Button,
  Swiper,
  Box,
  Image,
  useBreakpoint,
  Breakpoint,
} from '@betty/moonlight';
import { useDispatch, useSelector } from '@betty/toolkit/state';
import {
  fetchPromo,
  selectLandingPromos,
  selectLandingPromosDataState,
} from '@betty/auth';
import { Link } from 'react-router';
import { useNavigate } from 'react-router'

function PromosSection() {
  const dispatch = useDispatch();
  const landingPromos = useSelector(selectLandingPromos);
  const landingPromosDataState = useSelector(selectLandingPromosDataState);
  const navigate = useNavigate();

  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === Breakpoint.MOBILE;

  useEffect(() => {
    if (landingPromosDataState === 'idle') {
      dispatch(fetchPromo());
    }
  }, [dispatch, landingPromosDataState]);

  const swiperItems = [
    ...landingPromos.map((promo) => ({
      image: '',
      img: promo.bannerImageUrl,
      url: `/promos/${promo.slug}`,
      type: 'promo',
    })),
    {
      image: '',
      img: 'landingPage.seeAllPromos',
      url: '/promos',
      type: 'all',
    },
  ];

  return (
    <Box gap="space-400">
      <Link to="/promos">
        <Text variant="h4" gradient="darkSurfaceAccent">
          New promos every{' '}
          <span className="inline-item">
            day
            <Icon gradient="accentBackground" name="arrowForwardIosOutlined" />
          </span>
        </Text>
      </Link>

      <Box
        width="100%"
        flexDirection="column"
        alignItems="center"
        height={{
          desktop: 320,
          tablet: 320,
          mobile: 160,
        }}
      >
        <Swiper
          items={swiperItems}
          renderOverlayItem={(item) => (
            <Box position="relative">
              {item.type === 'promo' ? (
                <Link to={item?.url}>
                  <Image
                    width={isMobile ? 320 : 620}
                    height={isMobile ? 160 : 320}
                    source={item.img}
                    borderRadius="radius-400"
                    contentFit="cover"
                  />
                </Link>
              ) : (
                <Box position="relative">
                  <Image
                    width={isMobile ? 320 : 620}
                    height={isMobile ? 160 : 320}
                    name={item.img}
                    borderRadius="radius-400"
                    contentFit="cover"
                  />
                  <div
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                    }}
                  >
                    <Button
                      variant="primary"
                      locKey="See All Promos"
                      rightIcon="arrowForward"
                      onPress={() => navigate(item.url)}
                    />
                  </div>
                </Box>
              )}
            </Box>
          )}
          maxHeight="100%"
          loop={false}
          dragFree={true}
          slidesToScroll={2}
          itemsGap="space-400"
          arrows={isMobile ? false : true}
        />
      </Box>
    </Box>
  );
}

export default memo(PromosSection);
